var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"label":_vm.$ft(_vm.$attrs.label),"value":_vm.value,"type":"number"},on:{"input":_vm.onInput}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }